export type BoostSkewFilterState = {
  isBoostSkewed: boolean;
};

export const DEFAULT_BOOST_SKEW_FILTER_VALUE = false;
